<template>
  <v-menu>
    <template #activator="{ props }">
      <div class="d-inline-flex align-center user-data" v-bind="props" data-testid="ProfileMenu-Toggle">
        <div class="profile-username d-none d-md-block">
          {{ userStore.name }}
          <template v-if="isElder">
            <br />
            <span class="user-type">Vecāks</span>
          </template>
        </div>
        <span class="profile-image">{{ userEmoji }}</span>

        <v-icon class="profile-caret-down-icon" icon="fa-light fa-caret-down" />
      </div>
    </template>

    <div class="profile-menu-panel" data-testid="ProfileMenuPanel">
      <header class="profile-menu-header">
        <span class="profile-menu-avatar">{{ userEmoji }}</span>
        <div class="profile-menu-header-text">
          <h2>{{ userStore.name }}</h2>
          <p>{{ roleLabel }}</p>
        </div>
      </header>

      <v-list class="profile-menu-nav">
        <v-list-item
          class="profile-menu-nav-item"
          :class="{ active: route.path === '/profils' }"
          :ripple="false"
          data-testid="ProfileNav-MansProfils"
          @click="sendToProfile"
        >
          <template #prepend>
            <v-icon icon="fa-light fa-user" :size="20" />
          </template>
          <v-list-item-title>Mans profils</v-list-item-title>
        </v-list-item>
        <v-list-item
          class="profile-menu-nav-item"
          :class="{ active: route.path === '/profile/abonements' }"
          :ripple="false"
          data-testid="ProfileNav-Abonements"
          @click="sendToSubscriptions"
        >
          <template #prepend>
            <v-icon icon="fa-light fa-credit-card" :size="20" />
          </template>
          <v-list-item-title>Abonements</v-list-item-title>
        </v-list-item>
        <v-list-item
          class="profile-menu-nav-item"
          :ripple="false"
          data-testid="ProfileNav-Iziet"
          @click="signOutUser"
        >
          <template #prepend>
            <v-icon icon="fa-light fa-sign-out" :size="20" />
          </template>
          <v-list-item-title>Iziet</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </v-menu>
</template>

<script setup lang="ts">
import { ROLE_LABEL, type UserRole } from "~/constants/emojiVariants"
import { useUserStore } from "~/stores/userStore"

const userStore = useUserStore()
const route = useRoute()

const isElder = computed(() => userStore.current?.user_type === "elder")
const userEmoji = computed(() => userStore.current?.profile_emoji || "😊")
const roleLabel = computed(() => {
  const userType = userStore.current?.user_type as UserRole | undefined
  return userType ? ROLE_LABEL[userType] : ""
})

const sendToSubscriptions = () => {
  navigateTo("/profile/abonements")
}

const sendToProfile = () => {
  navigateTo("/profils")
}

const signOutUser = () => {
  userStore.logout()
}
</script>

<style lang="sass">
.user-data
  cursor: pointer
  gap: 8px

  .profile-caret-down-icon
    width: 13px
    font-size: 20px

  .profile-image
    width: 32px
    height: 32px
    display: inline-flex
    align-items: center
    justify-content: center
    font-size: 24px
    line-height: 1

  .profile-username
    line-height: 1rem

    .user-type
      font-size: 0.9rem

.profile-menu-panel
  width: 280px
  background: #FFFFFF
  border-radius: 16px
  padding: 16px
  margin-top: 8px
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08)
  display: flex
  flex-direction: column
  gap: 12px

.profile-menu-header
  display: flex
  align-items: center
  gap: 12px
  padding: 4px

  .profile-menu-avatar
    width: 48px
    height: 48px
    display: flex
    align-items: center
    justify-content: center
    font-size: 32px
    background: #F3F3F3
    border-radius: 12px
    flex-shrink: 0
    line-height: 1

  .profile-menu-header-text
    flex: 1
    min-width: 0

    h2
      font-size: 16px
      font-weight: 600
      line-height: 20px
      margin: 0
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap

    p
      font-size: 13px
      color: #6B6B6B
      margin: 2px 0 0
      line-height: 16px

.profile-menu-panel .profile-menu-nav
  display: flex
  flex-direction: column
  gap: 4px
  padding: 0
  overflow: visible
  background: transparent

  .profile-menu-nav-item
    min-height: 0
    padding: 10px 12px
    border-radius: 8px
    color: #333333
    cursor: pointer

    .v-list-item__overlay
      display: none

    .v-list-item__prepend
      .v-icon
        margin-inline-end: 12px
        opacity: 1

      .v-list-item__spacer
        display: none

    .v-list-item-title
      font-size: 15px
      font-weight: 500
      line-height: 20px

    &:hover
      background: rgba(0, 0, 0, 0.04)

    &.active
      background: #E2F2FE
      color: #0066B3

      .v-icon
        color: #0066B3
</style>
